import React from 'react';
import {
  CloseButton,
  Input,
  InputGroup,
  InputGroupProps,
  InputRightElement,
} from '@chakra-ui/react';

type Props = React.ComponentProps<typeof Input> & {
  onClear: () => void;
  containerProps?: InputGroupProps;
};

export function SearchInput(props: Props) {
  const {
    onClear,
    placeholder,
    value,
    width,
    containerProps,
    ...otherProps
  } = props;
  return (
    <InputGroup width={width ?? 300} {...containerProps}>
      <Input
        placeholder={placeholder ?? t('Search')}
        value={value}
        {...otherProps}
      />
      {value !== '' && (
        <InputRightElement>
          <CloseButton onClick={onClear} />
        </InputRightElement>
      )}
    </InputGroup>
  );
}
